<script xmlns="http://www.w3.org/1999/html">

import modalVerifyEmail from "../../components/modals/modal-verify-smtp-email";

export default {
  name: "setting-smtp-no-reply-email",
  data() {
    return {
      user: this.$A.Auth,
      oldNoReplyEmail: _.get(this, '$A.Auth.account.noReplyEmail', ""),
      newNoReplyEmail: _.get(this, '$A.Auth.account.noReplyEmail', ""),
      oldWhiteLabelDomainName: _.get(this, '$A.Auth.account.whiteLabelDomainName', ""),
      newWhiteLabelDomainName: _.get(this, '$A.Auth.account.whiteLabelDomainName', ""),
      emailConfiguration: _.get(this, '$A.Auth.account.emailConfiguration', ""),
      emailAuthorization: _.get(this, '$A.Auth.account.emailAuthorization', ""),
      emailSettings: {
        displayMethodType: "1",
        postmark: {
          returnPathDomainVerified: false,
          fromEmail: "",
          dkimVerified: false,
          dkimHost: "",
          returnPathDomainCNAMEValue: ""
        },
        smtpServer: {
          validated: false,
          fromEmail: "",
          smtpServerInfo: {
            userName: "",
            password: "",
            serverAddress: "",
            serverPort: 587,
          }
        }
      },
      validated: false,
      sendMethodStatus: {},
      displaySmtpInfoEditMode: false,
      isMobile: window.innerWidth < 991,
      serverWarningMsg: "",
      sendMethodStatusId: 0,
      displayDKIM: false,
      isProfileEmailAuthorize: false,
    };
  },
  components: {
    modalVerifyEmail
  },
  props: {
    isAccountSettings: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    isChangingProfileEmailAddressUponSaving: function () {
      return !this.$props.isAccountSettings && this.user.email !== this.newNoReplyEmail;
    },
    isChangingProfileEmailAddressUponSavingSmtp: function () {
      return !this.$props.isAccountSettings && this.emailSettings.smtpServer.fromEmail !== "" && this.user.email !== this.emailSettings.smtpServer.fromEmail;
    },
    supportedEmail: function () {
      const email = this.emailSettings.displayMethodType === '1' ? this.newNoReplyEmail : this.emailSettings.smtpServer.fromEmail;
      if (!email) return false;
      if (email.indexOf("gmail.com") !== -1) {
        return false;
      }
      if (email.indexOf("hotmail.com") !== -1) {
        return false;
      }
      if (email.indexOf("yahoo.com") !== -1) {
        return false;
      }
      if (email.indexOf("outlook.com") !== -1) {
        return false;
      }
      if (email.indexOf("icloud.com") !== -1) {
        return false;
      }
      if (email.indexOf("aol.com") !== -1) {
        return false;
      }
      return true;
    },
    smtpVerified: function () {
      return this.emailSettings.displayMethodType === "2" && this.emailSettings.smtpServer.validated;
    },
    isEmailAddressMatchingSettings: function () {
      if (this.$props.isAccountSettings)
        return true;
      if (this.emailSettings.displayMethodType === "1")
        return this.emailSettings.postmark.fromEmail === _.get(this, 'user.email', "");
      if (this.emailSettings.displayMethodType === "2")
        return this.emailSettings.smtpServer.fromEmail === _.get(this, 'user.email', "");
    },
    isDisabled: function () {
      return !_.get(this, 'user.account.subscriptionState.whiteLabelEnabled', false);
    },
    isPostmarkEmailAddressSameAsCurrentUserEmailAddress: function () {
      return this.newNoReplyEmail !== _.get(this, 'user.email', "");
    },
    isValidSubscriptionState: function () {
      const planType = _.get(this, "$A.Auth.account.subscriptionState.sku", "").split('-')[0];
      if (this.isAccountSettings) {
        return _.includes([
          'premium',
          'enterprise',
        ], planType);
      } else {
        return _.includes([
          'premium',
          'enterprise',
          'standard',
          'design',
          'freelancer',
          'starter',
        ], planType)
      }
    },
    isDkimVerified: function () {
      return this.emailSettings.postmark.dkimVerified;
    },
    hasDkimData: function () {
      return this.emailSettings.postmark.dkimPendingHost || this.emailSettings.postmark.dkimPendingTextValue;
    },
    isSpfVerified: function () {
      return this.emailSettings.postmark.spfVerified;
    },
    hasSpfData: function () {
      return this.emailSettings.postmark.domain || this.emailSettings.postmark.spfTextValue;
    },
    isReturnPathDomainVerified: function () {
      return this.emailSettings.postmark.returnPathDomainVerified;
    },
    hasReturnPathDomainData: function () {
      return this.emailSettings.postmark.domain || this.emailSettings.postmark.returnPathDomainCNAMEValue
    },
    isPostMarkEmailVerified: function () {
      return this.emailSettings.postmark.confirmed;
    },
    isSmtpServerValidated: function () {
      return this.emailSettings.smtpServer.emailValidated;
    },
    isAllVerifiedForPostmark: function () {
      return this.isDkimVerified && this.isReturnPathDomainVerified && this.isSpfVerified;
    },
    hasDomainConfigData: function () {
      return this.hasDkimData || this.hasReturnPathDomainData || this.hasSpfData;
    },
    displayDomainConfiguration: function () {
      return this.emailSettings.postmark.dkimPendingHost || this.emailSettings.postmark.dkimPendingTextValue ||
          this.emailSettings.postmark.domain || this.emailSettings.postmark.returnPathDomainCNAMEValue;
    },
    showRemoveBtn: function () {
      if (this.emailSettings.displayMethodType === "1") {
        return this.isProfileEmailAuthorize || this.emailSettings.postmark.id > 0;
      }
      return (this.isProfileEmailAuthorize || this.emailSettings.smtpServer.id > 0) && !this.displaySmtpInfoEditMode;
    },
    shouldHideSmtpAuthorizeBtn: function () {
      return this.isAccountSettings && this.emailSettings.displayMethodType === '2' && !this.displaySmtpInfoEditMode;
    },
    shouldDisabledAccountAuthorizeBtn: function () {
      return this.isAccountSettings && this.emailSettings.displayMethodType === '1' && this.newNoReplyEmail === this.oldNoReplyEmail && this.emailSettings.postmark.confirmed;
    }
  },
  methods: {
    resetEmailSettings: async function () {
      if (this.isAccountSettings) {
        await this.$A.AccountService.ResetAccountSendMethod(this.emailSettings.displayMethodType);
      } else {
        await this.$A.UserService.ResetUserSendMethod(this.emailSettings.displayMethodType);
      }
      this.emailSettings = {
        displayMethodType: "1",
        postmark: {
          returnPathDomainVerified: false,
          fromEmail: "",
          dkimVerified: false,
          dkimHost: "",
          returnPathDomainCNAMEValue: ""
        },
        smtpServer: {
          validated: false,
          fromEmail: "",
          smtpServerInfo: {
            userName: "",
            password: "",
            serverAddress: "",
            serverPort: 587,
          }
        }
      };
      await this.GetEmailSettings();
      this.isProfileEmailAuthorize = false;
    },
    updateEmailSettings: async function () {
      this.sendMethodStatusId = 0;
      if (this.emailSettings.displayMethodType === '1') {
        if (this.$props.isAccountSettings) {
          if (!this.isPostmarkEmailAddressSameAsCurrentUserEmailAddress) {
            return this.$A.AlertUser("No Reply Email Cannot be same as Account Email Address");
          }
          if (this.oldNoReplyEmail !== this.newNoReplyEmail) {
            this.displayDKIM = true;
          }
          this.validated = true;
          if (this.newNoReplyEmail !== this.oldNoReplyEmail) {
            let emailResult = await this.UpdateEmail(this.newNoReplyEmail);
            if (!emailResult || emailResult.noReplyEmail === undefined) {
              return;
            }
          }
        }
        this.sendMethodStatusId = await this.SavePostmarkSendMethod();
        if (this.sendMethodStatusId > 0) {
          this.isProfileEmailAuthorize = true;
        }
      } else if (this.emailSettings.displayMethodType === '2') {
        if (!this.displaySmtpInfoEditMode) {
          return this.$A.AlertUser("Please edit server info before saving");
        }

        let email = this.emailSettings.smtpServer.fromEmail;
        let username = this.emailSettings.smtpServer.smtpServerInfo.userName;
        let password = this.emailSettings.smtpServer.smtpServerInfo.password;
        let serverAddress = this.emailSettings.smtpServer.smtpServerInfo.serverAddress;
        let serverPort = this.emailSettings.smtpServer.smtpServerInfo.serverPort;

        if (!email || !username || !password || !serverAddress || !serverPort) {
          this.$A.AlertUser("Please Fill Out The SMTP Server Form First");
          return;
        }

        let accountResult = await this.UpdateEmail(email);
        if (!accountResult || !accountResult.noReplyEmail) {
          return;
        } else {
          this.sendMethodStatusId = await this.SaveSmtpMethod({email, username, password, serverAddress, serverPort});
        }
      }

      if (this.sendMethodStatusId > 0) {
        this.$bvModal.show("verifyEmailSignatureModal");
        this.VerifyEmailStatus();
      }
    },
    SavePostmarkSendMethod: async function () {
      return this.isAccountSettings ?
          this.$A.AccountService.SaveAccountPostmarkSendMethod() :
          this.$A.UserService.SaveUserPostmarkSendMethod();
    },
    SaveSmtpMethod: async function (smtpServerInfo) {
      return this.isAccountSettings ?
          this.$A.AccountService.SaveAccountSmtpSendMethod(smtpServerInfo) :
          this.$A.UserService.SaveUserSmtpSendMethod(smtpServerInfo);
    },
    UpdateEmail: async function (email) {
      return this.isAccountSettings ?
          this.UpdateAccountEmail(email) :
          this.UpdateUserEmail(email);
    },
    UpdateAccountEmail: async function (email) {
      const account = await this.$A.AccountService.UpdateAccount(
          null,
          email,
          null,
          null,
          null,
          null
      );

      if (account && _.get(account, 'success', true)) {
        this.$A.Auth.account = account;
        this.$A.SaveSessionData(this.$A.Auth);
      }

      return account;
    },
    UpdateUserEmail: async function (email) {
      let user = await this.$A.UserService.UpdateUser(
          this.$A.Auth.id,
          {email}
      );

      if (user && _.get(user, 'success', true)) {
        this.$A.Auth = user;
        this.$A.SaveSessionData(this.$A.Auth);
        user = {...user, noReplyEmail: user.email};
      }

      return user;
    },
    VerifyEmailStatus: function () {
      let self = this;
      setTimeout(async () => {
        const status = await self.GetSendMethodStatus(self.sendMethodStatusId, self.emailSettings.displayMethodType);
        const error = _.get(status, ['errors', 0]);
        if (error) {
          self.$bvModal.hide("verifyEmailSignatureModal");
          return this.$A.AlertUser(error);
        }
        const postMarkStatusVerified = self.emailSettings.displayMethodType === '1' && _.get(status, 'postMarkStatus.confirmed');
        const smtpStatusVerified = self.emailSettings.displayMethodType === '2' && _.get(status, 'smtpStatus.emailValidated');
        if (postMarkStatusVerified || smtpStatusVerified) {
          self.$bvModal.hide("verifyEmailSignatureModal");
          await self.GetEmailSettings();
          if (smtpStatusVerified) {
            this.displaySmtpInfoEditMode = false;
          }
        } else {
          self.setSendMethodStatus(status, self.emailSettings.displayMethodType);
          self.VerifyEmailStatus();
        }
      }, 5000);
    },
    setSendMethodStatus: function (status, type) {
      const typeName = this.TypeIdToName(type);
      if (typeName === 'postmark' && status.postMarkStatus) {
        this.emailSettings[typeName] = status.postMarkStatus;
        this.emailSettings[typeName].fromEmail = status.postMarkStatus.emailAddress;
      }
    },
    cancelEmailVerification: function () {
      this.sendMethodStatusId = 0;
    },
    GetSendMethodStatus: function (methodStatusId, methodType) {
      return this.isAccountSettings ?
          this.$A.AccountService.GetAccountSendMethodStatus(methodStatusId, methodType) :
          this.$A.UserService.GetUserSendMethodStatus(methodStatusId, methodType);
    },
    EditSmtpServerInfo: function () {
      this.displaySmtpInfoEditMode = true;
    },
    TypeIdToName: function (type) {
      return (type === 1 || type === '1') ? 'postmark' : 'smtpServer';
    },
    GetEmailSettings: async function () {
      const allSendMethods = await (this.isAccountSettings ? this.$A.AccountService.GetAccountAllSendMethods() : this.$A.UserService.GetUserAllSendMethods());
      if (allSendMethods) {
        for (const s of allSendMethods) {
          if (s.isSelected) {
            this.emailSettings.displayMethodType = `${s.type}`;
            this.emailSettings[this.TypeIdToName(s.type)] = s;
            if (s.type === 1) {
              let status = await this.GetSendMethodStatus(s.settingId, s.type);
              this.setSendMethodStatus(status, s.type);
            }
          }
        }
      }

      if (this.emailSettings.postmark.fromEmail) {
        this.newNoReplyEmail = this.emailSettings.postmark.fromEmail;
        this.oldNoReplyEmail = this.emailSettings.postmark.fromEmail;
      }
      if (!this.emailSettings.smtpServer.smtpServerInfo) {
        this.emailSettings.smtpServer.smtpServerInfo = {
          userName: "",
          password: "",
          serverAddress: "",
          serverPort: 587,
        };
      }
      if (!this.emailSettings.smtpServer.smtpServerInfo.userName) {
        this.displaySmtpInfoEditMode = true;
      }
    },
  },
  async mounted() {
    await this.GetEmailSettings();
    const auth = _.get(this, '$A.Auth');
    if (auth) { 
      if (!this.$props.isAccountSettings) {
        this.emailSettings.smtpServer.fromEmail = auth.email;
        this.emailSettings.smtpServer.smtpServerInfo.userName = auth.email;
        this.newNoReplyEmail = auth.email;
      } else {
        const noReplyEmail = _.get(auth, 'account.noReplyEmail', '');
        this.emailSettings.smtpServer.fromEmail = noReplyEmail;
        this.emailSettings.smtpServer.smtpServerInfo.userName = noReplyEmail;
        this.newNoReplyEmail = noReplyEmail;
      }
    }
  },
}
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">{{ isAccountSettings ? 'Account Email Settings' : 'Email Integration' }}</div>
      <div class="card-head-subtitle">
        {{ isAccountSettings ? 'Send Ashore emails from your own no-reply address.' : 'Send proof emails from your own address instead of proofs@ashoreapp.org.' }}
      </div>
    </div>
    <div class="card-body">
      <div class="field-label mb-2">{{ isAccountSettings ? 'No-Reply Email Address' : 'Your Profile Email' }}</div>

      <!-- Method selection -->
      <div class="method-cards">
        <label class="method-card" :class="{ 'is-selected': emailSettings.displayMethodType === '1', 'is-disabled': !isValidSubscriptionState }" for="postmark-email-link">
          <input
              type="radio"
              id="postmark-email-link"
              name="postmark-link"
              value="1"
              class="method-radio"
              v-model="emailSettings.displayMethodType"
              :disabled="!isValidSubscriptionState"
          />
          <span class="method-dot"></span>
          <span class="method-text">
            <span class="method-title">Integrate Your Email With Postmark</span>
            <span class="method-description">We verify your address and send on your behalf — no server details needed.</span>
          </span>
        </label>
        <label class="method-card" :class="{ 'is-selected': emailSettings.displayMethodType === '2', 'is-disabled': !isValidSubscriptionState }" for="email-server-link">
          <input
              type="radio"
              id="email-server-link"
              name="server-link"
              value="2"
              class="method-radio"
              v-model="emailSettings.displayMethodType"
              :disabled="!isValidSubscriptionState"
          />
          <span class="method-dot"></span>
          <span class="method-text">
            <span class="method-title">Send Email From Your Own Server</span>
            <span class="method-description">Connect your SMTP server and emails go out through your own infrastructure.</span>
          </span>
        </label>
      </div>

      <!--  unsupported provider  -->
      <div class="warning-banner mt-3"
           v-show="!supportedEmail && emailSettings.displayMethodType === '1'">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        Your email provider is not currently supported. Business emails are required to integrate your email with Ashore.
      </div>

      <!--  postmark email active  -->
      <div v-show="emailSettings.displayMethodType === '1'">
        <!-- No-Reply Email Input (account only) -->
        <div class="field mt-3" @click="isDisabled ? $A.BuyNow(): null" v-show="isAccountSettings">
          <input
              type="text"
              :class="'text-input '  + (validated ? (isPostmarkEmailAddressSameAsCurrentUserEmailAddress ? 'is-valid':'is-invalid') : '') + (isDisabled ? ' disabled-input': '')"
              placeholder=""
              v-model="newNoReplyEmail"
              :disabled="isDisabled"
          />
        </div>
        <div v-show="!isPostmarkEmailAddressSameAsCurrentUserEmailAddress && $props.isAccountSettings"
             class="invalid-feedback">Cannot be same as Account Address.
        </div>

        <!--  Profile status -->
        <div v-show="!isAccountSettings">
          <div :class="emailSettings.postmark.confirmed ? 'status-banner status-verified' : 'status-banner status-unverified'"
               v-if="!isAccountSettings && emailSettings.displayMethodType === '1' && isValidSubscriptionState">
            <div class="status-head">
              <svg v-if="emailSettings.postmark.confirmed" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              <svg v-else width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              <span>{{ emailSettings.postmark.confirmed ? 'Email Sender Signature is Verified' : 'Email Sender Signature is Not Verified' }}</span>
            </div>
            <ul v-show="!emailSettings.postmark.confirmed" class="status-notes">
              <li>Emails will be sent from proofs@ashoreapp.org until you authorize your email</li>
              <li>Select authorize below to begin the verification process</li>
            </ul>
          </div>
        </div>

        <!-- Account status -->
        <div
            :class="emailSettings.postmark.confirmed || oldNoReplyEmail === 'proofs@ashoreapp.org' ? 'status-banner status-verified' : 'status-banner status-unverified'"
            v-show="isAccountSettings">
          <div class="status-head">
            <svg v-if="emailSettings.postmark.confirmed || oldNoReplyEmail === 'proofs@ashoreapp.org'" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <svg v-else width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            <span>{{ emailSettings.postmark.confirmed || oldNoReplyEmail === 'proofs@ashoreapp.org' ? 'Email Sender Signature is Verified' : 'Email Sender Signature Not Verified' }}</span>
          </div>
        </div>

        <!-- Domain configuration (profile + account) -->
        <div v-show="!isAllVerifiedForPostmark && hasDomainConfigData" class="domain-config">
          <div class="domain-title">Domain Configuration</div>
          <div class="domain-subtitle">Add these records to your DNS to improve email deliverability.</div>

          <div class="record-card" :class="isDkimVerified ? 'is-verified' : 'is-unverified'" v-show="hasDkimData">
            <div class="record-head">
              <span class="record-pill">{{ isDkimVerified ? 'DKIM Verified' : 'DKIM Not Verified' }}</span>
            </div>
            <div class="record-row">
              <span class="record-label">Hostname</span>
              <span class="record-value">{{ emailSettings.postmark.dkimPendingHost }}</span>
            </div>
            <div class="record-row">
              <span class="record-label">TEXT</span>
              <span class="record-value">{{ emailSettings.postmark.dkimPendingTextValue }}</span>
            </div>
          </div>

          <div class="record-card" :class="isReturnPathDomainVerified ? 'is-verified' : 'is-unverified'" v-show="hasReturnPathDomainData">
            <div class="record-head">
              <span class="record-pill">{{ isReturnPathDomainVerified ? 'Return-Path' : 'Return-Path Inactive' }}</span>
            </div>
            <div class="record-row">
              <span class="record-label">Hostname</span>
              <span class="record-value">pm-bounces.{{ emailSettings.postmark.domain }}</span>
            </div>
            <div class="record-row">
              <span class="record-label">CNAME</span>
              <span class="record-value">{{ emailSettings.postmark.returnPathDomainCNAMEValue }}</span>
            </div>
          </div>

          <div class="record-card" :class="isSpfVerified ? 'is-verified' : 'is-unverified'" v-show="hasSpfData">
            <div class="record-head">
              <span class="record-pill">{{ emailSettings.postmark.spfVerified ? 'SPF' : 'SPF Inactive' }}</span>
            </div>
            <div class="record-row">
              <span class="record-label">Hostname</span>
              <span class="record-value">{{ emailSettings.postmark.domain }}</span>
            </div>
            <div class="record-row">
              <span class="record-label">TEXT</span>
              <span class="record-value">{{ emailSettings.postmark.spfTextValue }}</span>
            </div>
            <div class="record-row">
              <span class="record-label">Note</span>
              <span class="record-value">Merge this with your spf and don't overwrite.</span>
            </div>
          </div>
        </div>
      </div>

      <!--  server email active -->
      <div v-if="emailSettings.displayMethodType === '2'" class="mt-3">
        <div @click="isDisabled ? $A.BuyNow(): null">
          <!-- Edit mode -->
          <div
               v-if="(emailSettings.smtpServerInfo === null && emailSettings.displayMethodType === '2') || (emailSettings.smtpServerInfo !== null && emailSettings.displayMethodType === '2' && displaySmtpInfoEditMode)">
            <div class="smtp-fields">
              <div class="field">
                <label class="field-label">Email Address</label>
                <input type="text" name="email" class="text-input"
                       v-model="emailSettings.smtpServer.fromEmail"/>
              </div>
              <div v-show="isChangingProfileEmailAddressUponSavingSmtp" class="warning-banner">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                  <line x1="12" y1="9" x2="12" y2="13" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
                If you use a different email address as you have in your profile this will change your email address for your profile. Please remember that when logging in.
              </div>
              <div class="field">
                <label class="field-label">Username (Optional)</label>
                <input type="text" name="email" class="text-input"
                       v-model="emailSettings.smtpServer.smtpServerInfo.userName"/>
              </div>
              <div class="field">
                <label class="field-label">Password</label>
                <input type="password" name="password" class="text-input"
                       v-model="emailSettings.smtpServer.smtpServerInfo.password"/>
              </div>
              <div class="field">
                <label class="field-label">Outgoing Mail</label>
                <div class="server-row">
                  <input type="text" name="outgoing-mail" class="text-input server-address"
                         placeholder="smtp.example.com"
                         v-model="emailSettings.smtpServer.smtpServerInfo.serverAddress"/>
                  <input type="text" name="port" class="text-input server-port" placeholder="465"
                         v-model="emailSettings.smtpServer.smtpServerInfo.serverPort"/>
                </div>
              </div>
            </div>
          </div>
          <!-- Summary mode -->
          <div class="smtp-summary"
               v-if="emailSettings.smtpServerInfo !== null
               && emailSettings.displayMethodType === '2' && !displaySmtpInfoEditMode"
          >
            <div class="summary-row">
              <span class="summary-label">Email Address</span>
              <span class="summary-value">{{ emailSettings.smtpServer.fromEmail }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Outgoing Mail</span>
              <span class="summary-value">{{ emailSettings.smtpServer.smtpServerInfo.serverAddress }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Port</span>
              <span class="summary-value">{{ emailSettings.smtpServer.smtpServerInfo.serverPort }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Status</span>
              <span :class="smtpVerified ? 'status-pill pill-verified' : 'status-pill pill-unverified'">
                {{ smtpVerified ? 'Email is Verified' : 'Email is Not Verified' }}
              </span>
            </div>
            <div class="summary-actions">
              <button type="button" class="secondary-btn" @click="EditSmtpServerInfo">Edit</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Verify Email Modal -->
      <modal-verify-email name="verifyEmailSignatureModal" @cancel-verification="cancelEmailVerification"/>
    </div>
    <div class="card-foot">
      <!--  Profile Settings Remove -->
      <a v-if="!isAccountSettings && showRemoveBtn"
         class="danger-btn"
         @click="resetEmailSettings"
      >Reset</a>
      <!--  Account Settings Authorize -->
      <a v-if="isValidSubscriptionState && isAccountSettings"
         data-cy="updateAccountInfoBtn"
         :class="shouldHideSmtpAuthorizeBtn ? 'd-none' : ''"
         class="primary-btn"
         :disabled="shouldDisabledAccountAuthorizeBtn || !supportedEmail"
         :style="shouldDisabledAccountAuthorizeBtn ? ' pointer-events: none; opacity: 0.5':''"
         @click="updateEmailSettings"
      >Authorize</a>
      <a v-if="isValidSubscriptionState && !isAccountSettings && !showRemoveBtn"
         data-cy="updateAccountInfoBtn"
         class="primary-btn"
         :class="showRemoveBtn ? 'd-none' : ''"
         :enabled="supportedEmail"
         @click="updateEmailSettings"
      >Authorize</a>
      <!--  Feature Locked Btn -->
      <a v-if="!isValidSubscriptionState"
         class="locked-btn"
         @click="$A.BuyNow()"
         v-b-tooltip.hover="'Upgrade to integrate your email'">
        Feature Locked <img src="/img/feature-lock.svg" class="feature-icon ml-2"/>
      </a>
    </div>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-body {
  padding: 20px;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}
.field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.text-input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  color: #1f2937;
  background: #fff;
  outline: none;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.text-input:focus {
  border-color: #019256;
  box-shadow: 0 0 0 3px rgba(1, 146, 86, 0.12);
}
.disabled-input {
  background-color: #f3f4f6 !important;
  opacity: 1 !important;
}

/* Method cards */
.method-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.method-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px;
  margin: 0;
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 120ms ease, background-color 120ms ease;
}
.method-card:hover {
  border-color: rgba(1, 146, 86, 0.4);
}
.method-card.is-selected {
  border-color: #019256;
  background: rgba(1, 146, 86, 0.04);
  box-shadow: 0 0 0 1px #019256;
}
.method-card.is-disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.method-radio {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.method-dot {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-top: 2px;
  border-radius: 999px;
  border: 1.5px solid #c2c8d0;
  background: #fff;
  transition: border-color 120ms ease;
}
.method-card.is-selected .method-dot {
  border: 5px solid #019256;
}
.method-text {
  min-width: 0;
}
.method-title {
  display: block;
  font-size: 13.5px;
  font-weight: 600;
  color: #111827;
}
.method-description {
  display: block;
  margin-top: 1px;
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
  line-height: 1.5;
}

/* Banners */
.warning-banner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 12px 0;
  padding: 10px 14px;
  border-radius: 8px;
  background: rgba(235, 70, 84, 0.08);
  color: #b43643;
  font-size: 12.5px;
  font-weight: 500;
  line-height: 1.5;
}
.warning-banner svg {
  flex-shrink: 0;
  margin-top: 2px;
}
.status-banner {
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
}
.status-verified {
  background: rgba(1, 146, 86, 0.08);
  color: #017a48;
}
.status-unverified {
  background: rgba(235, 70, 84, 0.08);
  color: #b43643;
}
.status-head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}
.status-head svg {
  flex-shrink: 0;
}
.status-notes {
  margin: 8px 0 0;
  padding-left: 24px;
  font-size: 12.5px;
  font-weight: 400;
  line-height: 1.6;
}

/* Domain configuration */
.domain-config {
  margin-top: 18px;
}
.domain-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #111827;
}
.domain-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  color: #6b7280;
}
.record-card {
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid rgba(15, 23, 42, 0.06);
}
.record-card.is-verified {
  background: rgba(1, 146, 86, 0.06);
}
.record-card.is-unverified {
  background: rgba(235, 70, 84, 0.06);
}
.record-head {
  margin-bottom: 8px;
}
.record-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}
.is-verified .record-pill {
  background: rgba(1, 146, 86, 0.14);
  color: #017a48;
}
.is-unverified .record-pill {
  background: rgba(235, 70, 84, 0.12);
  color: #b43643;
}
.record-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 4px 0;
  font-size: 12.5px;
}
.record-label {
  flex-shrink: 0;
  min-width: 110px;
  font-weight: 600;
  color: #4b5563;
}
.record-value {
  color: #1f2937;
  font-family: SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
  overflow-wrap: anywhere;
  text-align: right;
}

/* SMTP */
.smtp-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 520px;
}
.server-row {
  display: flex;
  gap: 10px;
}
.server-address {
  flex: 1;
}
.server-port {
  width: 110px;
  flex-shrink: 0;
}
.smtp-summary {
  padding: 14px 16px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  background: #fbfbfc;
  max-width: 520px;
}
.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 6px 0;
  font-size: 12.5px;
}
.summary-label {
  font-weight: 600;
  color: #4b5563;
}
.summary-value {
  color: #1f2937;
  overflow-wrap: anywhere;
  text-align: right;
}
.summary-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.status-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}
.pill-verified {
  background: rgba(1, 146, 86, 0.12);
  color: #017a48;
}
.pill-unverified {
  background: rgba(235, 70, 84, 0.1);
  color: #b43643;
}

/* Buttons */
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.primary-btn:hover {
  background: #017a48;
  color: #fff;
  text-decoration: none;
}
.secondary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  padding: 0 14px;
  background: #fff;
  color: #1f2937;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 6px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 120ms ease, color 120ms ease;
}
.secondary-btn:hover {
  border-color: #019256;
  color: #019256;
}
.danger-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  background: transparent;
  color: #b43643;
  border: 1px solid rgba(235, 70, 84, 0.35);
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease, border-color 120ms ease;
}
.danger-btn:hover {
  background: rgba(235, 70, 84, 0.06);
  border-color: #b43643;
  color: #b43643;
  text-decoration: none;
}
.locked-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  background: #F44271;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
}
.locked-btn:hover {
  opacity: 0.9;
  color: #fff;
  text-decoration: none;
}
.feature-icon {
  height: 14px;
}

@media (max-width: 767px) {
  .method-cards {
    grid-template-columns: 1fr;
  }
  .server-row {
    flex-wrap: wrap;
  }
  .server-port {
    width: 110px;
  }
  .card-foot {
    flex-wrap: wrap;
  }
  .primary-btn,
  .danger-btn,
  .locked-btn {
    flex: 1;
  }
}
</style>
